// extracted by mini-css-extract-plugin
export default {"RHead":"Style_RHead__785Ad","RMSList":"Style_RMSList__6fSHW","addMilestoneBtn":"Style_addMilestoneBtn__4LcM2","svg":"Style_svg__X-SEz"};